scaleLeftMenu();
window.addEventListener("load", function() {
    scaleLeftMenu()

});
window.addEventListener("resize", function() {
    scaleLeftMenu();
});


function scaleLeftMenu() {
    let scaleRatio = $('body').data("scale-ratio");
    console.log("scaleRatio" + scaleRatio);
    $(".main-left-h5").css({
        transform: `scale(${scaleRatio})`,
        transformOrigin: 'left top'
    });
}